'use strict';
var React = require('react');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-31
 @Descript : 热区组件
 */
var HotSpot = React.createClass({

  render: function () {
    return (
      <div className="component-HotSport"></div>
    );
  }
});

module.exports = HotSpot;



/** WEBPACK FOOTER **
 ** ./src/views/Components/HotSpot.jsx
 **/